import { useCallback, useState } from 'react';

export const useActiveState = () => {
    const [isActive, setIsActive] = useState(false);
    const handleMouseLeave = useCallback(() => setIsActive(false), []);
    const handleFocus = useCallback(() => setIsActive(true), []);
    const handleBlur = useCallback((e) => {
        if (!e.target.contains(e.relatedTarget)) {
            setIsActive(false);
        }
    }, []);
    const handleMouseEnter = useCallback(() => {
        setIsActive(true);
    }, []);

    return {
        isActive,
        handleMouseEnter,
        handleMouseLeave,
        handleFocus,
        handleBlur,
    };
};
